import Head from "next/head";
import { useRouter } from "next/router";

type Props = {
  data: string;
};

export default function JsonLd(props: Props) {
  const router = useRouter();

  return (
    <Head key={router.asPath}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: props.data }} />
    </Head>
  );
}
